
















import { defineComponent, computed } from '@vue/composition-api'

import { IRecommend } from '@/types/recommend'

type Props = {
  brandSkus: IRecommend[]
  loading: boolean
}

export default defineComponent({
  name: 'BrandSkusTable',
  props: {
    brandSkus: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props) {
    const headers = [
      // { text: 'ID', value: 'id' },
      { text: '商品名', value: 'name' },
      { text: '商品コード', value: 'code' },
      { text: '価格', value: 'price' },
      { text: 'カテゴリー', value: 'category' },
      { text: 'スコア', value: 'score' },
    ]
    const items = computed(() =>
      props.brandSkus.map(m => {
        return {
          // id: m.id,
          name: m.name,
          code: m.code,
          price: m.price,
          category: m.category || '-',
          score: m._score,
        }
      }),
    )

    return { headers, items }
  },
})
